import { useEffect, useRef, useState } from 'react';

/**
 * Botón de privacidad (componentes.md §1e; aceptado por el equipo con la exportación): asterisco rojo abajo a la derecha.
 * Al tocarlo, el rojo (fondo vivo) sale de su esquina y tapa todo el panel con el asterisco blanco girando; tocar en
 * cualquier punto o pulsar cualquier tecla vuelve exactamente a donde estaba, con el foco donde lo tenía.
 */
const ASTERISCO = 'M613 545H642L638 581L672 567L681 594L646 601L671 627L648 645L627 613L607 645L584 627L610 601L575 594L584 567L617 581Z';

export function Privacidad({ abajo }: { abajo: string }) {
    const [fase, setFase] = useState<'cerrada' | 'abierta' | 'cerrando'>('cerrada');
    const [origen, setOrigen] = useState({ x: 0, y: 0 });
    const boton = useRef<HTMLButtonElement>(null);
    const antes = useRef<Element | null>(null);

    useEffect(() => {
        if (fase !== 'abierta') {
            return;
        }
        const vuelve = (e: Event) => {
            e.preventDefault();
            setFase('cerrando');
            setTimeout(() => {
                setFase('cerrada');
                if (antes.current instanceof HTMLElement) {
                    antes.current.focus();
                }
            }, 520);
        };
        window.addEventListener('keydown', vuelve, { once: true });
        return () => {
            window.removeEventListener('keydown', vuelve);
        };
    }, [fase]);

    const abrir = () => {
        const r = boton.current?.getBoundingClientRect();
        setOrigen({ x: r === undefined ? 0 : r.left + r.width / 2, y: r === undefined ? 0 : r.top + r.height / 2 });
        antes.current = document.activeElement;
        setFase('abierta');
    };

    return (
        <>
            <button ref={boton} type="button" className="rv-priv-b" aria-label="Tapar la pantalla" style={{ right: 16, bottom: abajo }} onClick={abrir}>
                <svg viewBox="567.83 535.93 120 120" aria-hidden="true">
                    <path d={ASTERISCO} />
                </svg>
            </button>
            {fase !== 'cerrada' && (
                <div
                    role="button"
                    tabIndex={0}
                    aria-label="Volver al panel"
                    className={`rv-priv${fase === 'cerrando' ? ' rv-priv-cierra' : ''}`}
                    style={{ ['--px' as string]: `${String(origen.x)}px`, ['--py' as string]: `${String(origen.y)}px` }}
                    onClick={() => {
                        setFase('cerrando');
                        setTimeout(() => {
                            setFase('cerrada');
                        }, 520);
                    }}
                >
                    <div className="rv-vivo" aria-hidden="true" />
                    <svg viewBox="567.83 535.93 120 120" aria-hidden="true">
                        <path d={ASTERISCO} />
                    </svg>
                </div>
            )}
        </>
    );
}
